// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__zBlm2","btn":"Pagination_btn__a0HJC","active":"Pagination_active__vveOm","ellipsis":"Pagination_ellipsis__Xk6OO","info":"Pagination_info__yOXmB"};